export default "__VITE_ASSET__VxQuBKgP__"